"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselContent = void 0;
exports.CarouselContent = {
  en: {
    ofText: "of"
  },
  fr: {
    ofText: "sur"
  },
  es: {
    ofText: "de"
  }
};